import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { useAffiliateTracking } from '@/utils/affiliate-tracking';

/**
 * Hook to integrate affiliate tracking with the authentication system
 * This should be used in the main App component or auth provider
 */
export function useAffiliateIntegration() {
	const { user, isLoading } = useAuth();
	const { initializeTracking, convertSession } = useAffiliateTracking();

	// Initialize tracking on app load
	useEffect(() => {
		if (!isLoading) {
			initializeTracking();
		}
	}, [isLoading, initializeTracking]);

	// Convert affiliate session when user signs up/logs in
	useEffect(() => {
		if (user && user._id) {
			// Check if this is a new user (you might want to add a flag for this)
			// For now, we'll convert on every login, but you could add logic to only convert once
			convertSession(user._id, 'signup');
		}
	}, [user, convertSession]);

	return {
		// You can return any affiliate-related state or functions here
		// For example, you might want to expose the current affiliate session
	};
}
